<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <!-- <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('BE')"
        >
          Auto-Expédition
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button> -->
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-sent-notes"
          v-if="auth.can('ADD_BE_S') && auth.can('BE')"
        >
          Ajouter Bon d'envoie ( SIMPLE )
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          to="/add-global-sent"
          v-if="auth.can('ADD_BE_G') && auth.can('BE')"
        >
          Ajouter Bon denvoie ( GLOBAL )
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows"
        :loading="isLoader"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        }"
        @select-all="selectNotes"
        @selected-rows-change="onSelectAllNotes"
      >
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
            <b>{{ props.row.note_ref }}</b>
          </span>
          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}
            </template>
            <span v-if="props.row.userc">{{ props.row.userc.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'sent_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.sent_time != null">
              {{ getDate(props.row.sent_time) }}<br />
            </template>
            <span v-if="props.row.suser">{{ props.row.suser.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'delivery_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.delivery_time != null">
              {{ getDate(props.row.delivery_time) }}
              <br />
            </template>
            <span v-if="props.row.userd">{{ props.row.userd.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'sending_zone_name'"
            class="text-nowrap"
          >
            <h6>{{ props.row.sending_zone_name }}</h6>
            <span>{{ props.row.sending_agency_name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'reception_zone_name'"
            class="text-nowrap"
          >
            <h6>{{ props.row.reception_zone_name }}</h6>
            <span>{{ props.row.reception_agency_name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'transport'"
            class="text-nowrap"
          >
            <h6>
              {{ props.row.transport }}
              <templat v-if="props.row.transport && props.row.transport_code"
                >({{ props.row.transport_code }})</templat
              >
            </h6>
            <small v-if="props.row.transport && props.row.transport_sacs"
              >{{ props.row.transport_sacs }} Sacs</small
            >
          </span>
          <span
            v-else-if="props.column.field === 'delivered'"
            class="text-nowrap"
          >
            {{ props.row.scanned }}
          </span>
          <template v-else-if="props.column.field === 'sent'">
            <span
              v-if="props.row.sent == 0 && props.row.delivered == 0"
              class="badge rounded-pill fs-13 text-bg-danger"
            >
              Attente d'expédition
            </span>

            <span
              v-else-if="props.row.sent == 0 && props.row.delivered == 4"
              class="badge rounded-pill fs-13 text-bg-primary"
            >
              Hors Zone
            </span>
            <span
              v-if="props.row.sent == 0 && props.row.delivered == 3"
              class="badge rounded-pill fs-13 text-bg-secondary"
            >
              Auto Ajout
            </span>
            <span
              v-else-if="props.row.sent == 1 && props.row.delivered == 0"
              class="badge rounded-pill fs-13 text-bg-info"
            >
              Expédié
            </span>
            <span
              v-if="
                props.row.delivered == 1 &&
                (props.row.sent == 1 ||
                  (props.row.sent == 0 &&
                    props.row.reception_agency == props.row.sending_agency))
              "
              class="badge rounded-pill fs-13 text-bg-success"
            >
              Reçu
            </span>
          </template>

          <template v-else-if="props.column.field === 'recu'">
            <!-- && props.row.delivered==0 -->
            <template v-if="props.row.sent == 1">
              <input
                type="checkbox"
                v-if="auth.can('BE') && auth.can('RECEIVE_BE')"
                v-model="props.row.recieved"
                class="custom-control-success"
                name="check-button"
                switch
                @change="recevedNote(props.row)"
                value="1"
                unchecked-value="0"
                :indeterminate="false"
                :disabled="
                  props.row.delivered == 1 &&
                  (props.row.sent == 1 ||
                    (props.row.sent == 0 &&
                      props.row.reception_agency == props.row.sending_agency))
                "
              />
            </template>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    (props.row.delivered == 3 || props.row.delivered == 4) &&
                    props.row.reception_agency != props.row.sending_agency
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="toExpedition(props.row)"
                  >
                    <i
                      class="flaticon-telegram lh-1 me-8 position-relative top-1"
                    ></i>
                    Vers Expédition
                  </button>
                </li>

                <li v-if="auth.can('BE') && props.row.sent == 1">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showModalRecieved(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li v-if="auth.can('BE') && props.row.sent == 0">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showModalRecieved(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    props.row.delivered == 0 &&
                    props.row.reception_agency != props.row.sending_agency
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="transportBon(props.row)"
                  >
                    <i
                      class="flaticon-express-delivery lh-1 me-8 position-relative top-1"
                    ></i>
                    Expédier
                  </button>
                </li>
                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.delivered == 0 &&
                    (props.row.sent == 1 ||
                      (props.row.sent == 0 &&
                        props.row.reception_agency == props.row.sending_agency))
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="distributionBon(props.row)"
                  >
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Reçu
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num == 0 &&
                    props.row.delivered == 0 &&
                    props.row.sent == 0
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeNote(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>

                <li>
                  <router-link
                    v-if="
                      auth.can('BE') &&
                      props.row.delivered == 0 &&
                      props.row.sent == 0 &&
                      props.row.type_note == 'SIMPLE'
                    "
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'EditSentNotePage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-edit lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>

                <!-- <li>
                  <router-link
                    v-if="
                      auth.can('BE') && props.row.delivered == 0 &&
              props.row.sent == 0 &&
              props.row.type_note == 'GLOBAL'
                    "
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'AddReceptionHCPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-edit2 lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li> -->

                <li>
                  <a
                    v-if="auth.can('BE') && props.row.parcels_num != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>
                <li>
                  <a
                    v-if="auth.can('BE') && props.row.parcels_num != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="ticketsPDF(props.row)"
                  >
                    <i
                      class="flaticon-menu-1 lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <div class="modal fade" id="modal_ShowBe" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <ShowEditBn
            :rowBE="noteRow"
            :getRecords="getRecords"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_ShowReceivedColi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <EditSentNote2 v-if="noteRow && Object.keys(noteRow).length != 0"  :rowBE="noteRow" :getRecords="getRecords" :type="true"  :isOpen="isOpen" />
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal_transport" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            Expedier le bon : {{ TransRow?.note_ref }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="expedierBon(TransRow.id)">
            <div class="row">
              <div class="col-12 mb-20">
                <div
                  class="form-group"
                  label="Choisir Transport"
                  label-for="trans"
                >
                  <label for="driver">Transport</label>
                  <v-select
                    class="custom-select-height"
                    :options="transportList"
                    v-model="transport"
                    label="name"
                  >
                    <!-- @search="onSearchTrans" <template slot="no-options">
                  Taper un mot pour chercher un transport
                </template> -->
                  </v-select>
                </div>
              </div>

              <div class="col-12 mb-20">
                <div
                  class="form-group"
                  label-for="name"
                  label="Le nombre de sacs"
                >
                  <label for="sacs">Le nombre de sacs</label>
                  <input
                    class="form-control"
                    v-model="sacs_transport"
                    name="sacs"
                    type="number"
                    min="0"
                  />
                </div>
              </div>

              <!-- <b-col cols="12">
            <div class="form-group" label-for="name" label="Frais Transport">
              <input class="form-control" v-model="fees_transport" type="number" min="0" />
            </div>
          </b-col> -->
              <div class="col-md-12" v-if="transport?.type == 2">
                <div class="form-group" label-for="name" label="Code d\'envoie">
                  <label for="code_transport">Code d'envoie</label>
                  <input
                    class="form-control"
                    v-model="code_transport"
                    name="name"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="expedierBon(TransRow.id)"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_distribution"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            Reçu le bon : {{ TransRow?.note_ref }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div
                class="form-group"
                label="Auto Distribution"
                label-for="distr"
              >
                <label for="driver">Auto distribution</label>
                <select class="form-control" v-model="auto_distr">
                  <option value="0">Non</option>
                  <option value="1">Oui</option>
                </select>
              </div>
            </div>

            <div v-if="auto_distr == 1" class="col-12">
              <label for="driver">Livreur</label>
              <div class="form-group" label="Livreur" label-for="distr">
                <!-- LivsZone -->
                <v-select :options="livsZone" v-model="livreur" label="name">
                </v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="reçuBon(TransRow.id)"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { dt } from "@fullcalendar/core/internal-common";
import router from "@/router";

import ShowEditBn from "@/components/Notes/SentNotes/ShowEditBn.vue";
import EditSentNote2 from "@/components/Notes/SentNotes/EditSentNote2.vue";

export default {
  name: "ListeNotes",
  components: {
    ShowEditBn,
    EditSentNote2,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const zonesList = ref([]);
    const transportList = ref([]);
    const transport = ref(null);
    const code_transport = ref("");
    const sacs_transport = ref("");
    const fees_transport = ref(null);
    const auto_distr = ref(0);
    const livreur = ref({ id: 0, name: null });
    const distrub = ref(null);
    const livsZone = ref([]);
    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "ENVOIE",
        field: "sending_zone_name",
      },
      {
        label: "RECEPTION",
        field: "reception_zone_name",
      },
      {
        label: "Type",
        field: "type_note",
      },
      {
        label: "Statut",
        field: "sent",
      },
      {
        label: "Date d'expédition",
        field: "sent_time",
      },
      {
        label: "Date de réception",
        field: "delivery_time",
      },
      {
        label: "Colis",
        field: "parcels_num",
        width: "100px",
      },
      {
        label: "Reçu",
        field: "delivered",
      },
      {
        label: "Transport",
        field: "transport",
      },
      // {
      //   label: "Bon Reçu",
      //   field: "recu",
      // },
      {
        label: "Action",
        field: "action",
      },
    ];

    // Declare missing refs for transportBon
    const TransRow = ref<{ id?: number; note_ref?: string } | null>(null);
    const transport_auto = ref({});
    const code_transport_auto = ref("");
    const fees_transport_auto = ref("");
    const sacs_transport_auto = ref("");
    const filters = reactive({
      searchTerm: "",
      searchSentZone: "",
      searchReceptZone: "",
      searchStatut: "",
      searchType: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      getRecords();
      api.get(`/api/auth/ActiveTransportList`).then((res) => {
        transportList.value = res.data;
      });
    });
    async function getRecords(page = 1) {
      isLoader.value = true;
      filters.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/ListSendNote?searchTerm=${filters.searchTerm}&searchSentZone=${filters.searchSentZone}&searchReceptZone=${filters.searchReceptZone}&searchStatut=${filters.searchStatut}&searchType=${filters.searchType}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str: string) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function onSearchZones(search: string, loading: (state: boolean) => void) {
      if (search.length && zonesList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/ListZone`).then((res) => {
          zonesList.value = res.data.users.data;
          zonesList.value.unshift({ id: "", name: "Tous" });
          loading(false);
        });
      }
    }

    function onSearchTrans(search: string, loading: (state: boolean) => void) {
      if (search.length && transportList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/ActiveTransportList`).then((res) => {
          transportList.value = res.data.users.data;
          loading(false);
        });
      }
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   customer_filter = store_filter = { id: '', name: '' }
      //   date_filter = status_filter = type_date_filter = ''
      //   $refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeNote(row) {
      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/RemoveSent/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon  est bien supprimé", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/SentPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function openReception(row) {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("ref_note", row.note_ref);
        data.append("cstmr", row.note_customer);
        const res = await api.post(`/api/auth/OpenBrc/${row.id}`, data);

        if (res.data.message === "success") {
          showToast("Bon de reception est bien modifié", "success");
          getRecords(); // 🔹 if Composition API. Use `getRecords()` if Options API.
        } else {
          showToast("Erreur, merci de réessayer encore!", "error");
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    async function ticketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketSentPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF (4 tickets)",
        });
      }
    }
    function showModal(row) {
      noteRow.value = {};
      // noteBmBL=[];
      noteRow.value = row;

      const modalEl = document.getElementById("detailBonModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function expedierBon(id) {
      if (Object.keys(transport).length !== 0) {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("note_id", id);
        data.append("trans_id", transport.value.id);
        data.append("trans_name", transport.value.name);
        data.append("code_transport", code_transport.value);
        data.append("sacs_transport", sacs_transport.value);

        const res = await api.post(`/api/auth/ExpedBE`, data);

        if (res.data.message === "success") {
          getRecords();
          const modalEl = document.getElementById("modal_transport");
          if (modalEl) {
            const modal = new Modal(modalEl);
            modal.hide();
          }
          showToast("Bon est bien expédié", "success");
        } else if (res.data.message === "error transport") {
          showToast("Transport choisi n'existe pas", "error");
        } else {
          showToast(
            "Vous ne pouvez pas ajouter à ce bon de livraison",
            "error"
          );
        }
      } else {
        showToast("Champs transport est obligatoire", "warning");
      }
    }

    async function reçuBon(id) {
      console.log(id);
      let data = new FormData();
      data.append("note_id", id);
      data.append("distr", auto_distr.value.toString());
      data.append("livreur", String(livreur.value.id || 0));
      data.append("liv_name", livreur.value.name || "");

      if (auto_distr.value == 1 && livreur.value.id == 0) {
        showToast("Merci de choisir un livreur!", "warning");
        return;
      }

      const result = await Swal.fire({
        text: "Vous voulez modifier ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, modifier!",
      });

      if (result.isConfirmed) {
        const res = await api.post(`/api/auth/DelivredBE`, data);
        if (res.data.message == "success") {
          getRecords();
           const modalEl = document.getElementById("modal_distribution");
      if (modalEl) {
          const modal = new Modal(modalEl);
          modal.show();
        }
        } else {
          showToast("Erreur est survenue!", "error");
        }
      }
    }

    async function distributionBon(row) {
      console.log(row);
      livreur.value = { id: 0, name: null };
      distrub.value = row;
      auto_distr.value = 0;
      TransRow.value = row;

      try {
        const res = await api.get(`/api/auth/LivsZone/${row.reception_zone}`);
        livsZone.value = res.data;
      } catch (error) {
        showToast("Erreur lors du chargement des livreurs", "error");
        console.log(error);
      }
      const modalEl = document.getElementById("modal_distribution");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function recevedNote(note) {
      try {
        const result = await Swal.fire({
          text: "Ce bon est reçu ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, Reçu!",
          cancelButtonText: "Annuler",
        });

        if (result.isConfirmed) {
          let data = new FormData();
          data.append("note_id", note.id);
          data.append("note_ref", note.note_ref);
          data.append("recieved", note.recieved);

          const res = await api.post(`/api/auth/recevedNoteSent`, data);

          if (res.data.message === "success") {
            showToast("Bon est bien reçu", "success");
            getRecords();
          } else if (
            res.data.message === "error note" ||
            res.data.message === "no perms"
          ) {
            showToast("Vous pouvez pas modifier ce bon", "error");
          } else {
            showToast("Erreur est survenue!", "error");
          }
        } else {
          note.recieved = !note.recieved;
        }
      } catch (error) {
        showToast("Something went wrong! Veuillez réessayer", "error");
        console.log(error);
      }
    }

    async function toExpedition(row) {
      try {
        const result = await Swal.fire({
          text: "Vous voulez modifier ce bon vers expédition?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, modifier!",
        });

        if (result.isConfirmed) {
          let data = new FormData();
          data.append("note_id", row.id);

          const res = await api.post(`/api/auth/toExpeditionBE`, data);

          if (res.data.message === "success") {
            showToast("Bon est bien modifié", "success");
            getRecords();
          } else {
            showToast(res.data.message || "Erreur est survenue!", "error");
          }
        }
      } catch (error) {
        showToast("Something went wrong! Veuillez réessayer", "error");
        console.log(error);
      }
    }

    const AutoNotes = ref([]);

    const selectNotes = (params) => {
      params.selectedRows.forEach((element) => {
        if (
          element.parcels_num != 0 &&
          element.sent == 0 &&
          element.reception_agency != element.sending_agency
        ) {
          if (!AutoNotes.value.includes(element)) {
            AutoNotes.value.push(element);
          }
        } else {
          element.vgtSelected = false;
        }
      });
    };
    const onSelectAllNotes = (params) => {
      params.selectedRows.forEach((element) => {
        if (
          element.parcels_num != 0 &&
          element.sent == 0 &&
          element.reception_agency != element.sending_agency
        ) {
          if (!AutoNotes.value.includes(element)) {
            AutoNotes.value.push(element);
          }
        } else {
          element.vgtSelected = false;
        }
      });
    };

    function transportBon(row) {
      // Reset transport-related refs
      transport.value = null;
      TransRow.value = null;

      code_transport.value = "";
      fees_transport.value = null;
      sacs_transport.value = "";

      // Declare TransRow and related variables before using them
      TransRow.value = row;
      transport_auto.value = {};
      code_transport_auto.value = "";
      fees_transport_auto.value = "";
      sacs_transport_auto.value = "";

      const modalEl = document.getElementById("modal_transport");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    const isOpen = ref(false);
    function showModalRecieved(row) {
      if (row.sent == 0) {
        noteRow.value = {};
        noteRow.value = row;
        // You can add logic to show a modal if needed
        const modalEl = document.getElementById("modal_ShowBe");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true;
          modal.show();
        }
      } else {
        noteRow.value = {};
        noteRow.value = row;
        // You can add logic to show a modal if needed
        const modalEl = document.getElementById("modal_ShowReceivedColi");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true;
          modal.show();
        }
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,
      showModal,
      removeNote,
      getPDF,
      openReception,
      noteRow,

      onSearchTrans,
      onSearchZones,
      expedierBon,
      reçuBon,
      distributionBon,
      recevedNote,
      toExpedition,
      selectNotes,
      onSelectAllNotes,
      transportBon,
      showModalRecieved,
      ticketsPDF,
      isOpen,

      transportList,
      transport,
      code_transport,
      sacs_transport,
      fees_transport,
      // Return missing refs
      TransRow,
      transport_auto,
      code_transport_auto,
      fees_transport_auto,
      sacs_transport_auto,

      livreur,
      livsZone,
      auto_distr,
    };
  },
};
</script>